import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Checkbox } from './va-checkbox';

@Component({
  selector: 'va-checkbox',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <mat-checkbox
      [disabled]="config.disabled"
      [checked]="config.checked"
      [indeterminate]="config.indeterminate"
      (change)="config.onClick($event.checked)"
    />
  `,
  standalone: false,
})
export class VaCheckboxComponent {
  @Input() config: Checkbox;
}
